import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Flex,
  Text,
  Checkbox,
  Button,
  VStack,
  HStack,
  Icon,
  Divider,
  useDisclosure,
  useToast,
  Drawer,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react';
import { FiFileText, FiDownload, FiEye } from 'react-icons/fi';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import LogoDashboard from '../../images/petalas-deovita.svg';
import Contrato from '../../termos/deovita202606.pdf';
import Pdf from 'components/PdfViewer';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function TermoDeAdesao() {
  const [aceito, setAceito] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const state = useLocation();
  const pdfUrl = 'http://deovita.com.br/wp-content/uploads/2026/03/Termo-de-Adesao-Deovita-1.pdf';
  const isMobile = /android|iphone|ipad|ipod/i.test(navigator.userAgent);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const { user, setUser } = useContext(AccountContext);
  const toast = useToast();
  const dados = state?.state?.dados;

  useEffect(() => {
    if (user?.termo === true) {
      if (!user.id_contrato && dados) {
        let carrinho = [{ id: 0, nome: dados.nome_plano, valor: dados.valor_plano_formatado, valor_numerico: dados.valor_plano }];
        navigate('/pagamentos', { state: { ...dados, carrinho: carrinho } });
        return;
      }
      navigate('/dashboard');
    }
  }, [user, dados, navigate]);
  async function postAceiteTermo() {
    try {
      setLoading(true);
      setError(null);
      await api(`${ENDPOINT}/pacientes/postAceiteTermoAdesao`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user: user.cpf, lat: user.lat, lng: user.lng, versao: '2026.04' }),
      })
        .then(async (res) => {
          if (!res || !res.ok || res.status >= 400) {
            console.log('Erro na resposta da API:', res);
            throw new Error('Erro na resposta da API');
          }
          return await res.json();
        })
        .then(async (resposta) => {
          if (!resposta || !(resposta.success === true || resposta.success === 'true')) {
            setLoading(false);
            setError(true);
            return;
          }
          if (user.id_contrato === 0 && dados) {
            let carrinho = [{ id: 0, nome: dados.nome_plano, valor: dados.valor_plano_formatado, valor_numerico: dados.valor_plano }];
            navigate('/pagamentos', { state: { ...dados, carrinho: carrinho } });
            return;
          }
          toast({
            duration: 4000,
            isClosable: true,
            position: 'bottom',
            render: () => (
              <Box
                display="flex"
                alignItems="center"
                bgGradient="linear(135deg, #5AB2AE 0%, #4AA09C 100%)"
                color="white"
                borderRadius="xl"
                boxShadow="lg"
                px={6}
                py={4}
                maxW="350px"
                mx="auto"
              >
                <Box
                  minW="48px"
                  minH="48px"
                  maxW="48px"
                  maxH="48px"
                  mr={4}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="full"
                  boxShadow="md"
                  border="2px solid #5AB2AE"
                  overflow="hidden"
                >
                  <img src={LogoDashboard} alt="Logo DeoVita" style={{ width: '40px', height: '40px', objectFit: 'contain', display: 'block' }} />
                </Box>
                <Box>
                  <Text fontWeight="bold" fontSize="lg" mb={1} color="#fff">
                    Sucesso
                  </Text>
                  <Text fontSize="sm" color="#fff">
                    Termo de adesão aceito com sucesso!
                  </Text>
                </Box>
              </Box>
            ),
          });
          navigate('/dashboard');
          setUser({ ...user, termo: true });
        })
        .catch((err) => {
          console.error('Erro no fluxo postAceiteTermo:', err);
          setLoading(false);
          setError(true);
        });
    } catch {
      setLoading(false);
      setError(true);
    }
  }
  const termosGeraisApp = useDisclosure();
  return (
    <Flex minH="100vh" bg="linear-gradient(135deg, #5AB2AE 0%, #4AA09C 100%)" align="center" justify="center" px={4}>
      <Box
        bg="white"
        w="100%"
        maxW="500px"
        p={8}
        borderRadius="3xl"
        boxShadow="0 20px 40px rgba(0,0,0,0.12)"
        border="1px solid"
        borderColor="whiteAlpha.400"
      >
        <VStack spacing={3} mb={8} textAlign="center">
          <Flex w="64px" h="64px" align="center" justify="center" bg="teal.50" borderRadius="full" boxShadow="inset 0 0 0 6px #E6F4F3">
            <Icon as={FiFileText} boxSize={7} color="#5AB2AE" />
          </Flex>
          <Text fontSize="lg" fontWeight="semibold" letterSpacing="tight" color="#5AB2AE">
            Termos do Contrato de Adesão
          </Text>
          <Text fontSize="sm" color="gray.500">
            Revise o documento antes de prosseguir
          </Text>
        </VStack>

        <HStack spacing={4} mb={8}>
          <Drawer isCentered isFullHeight size="md" isOpen={termosGeraisApp.isOpen} onClose={termosGeraisApp.onClose} placement="bottom">
            <DrawerContent isCentered nbgColor="rgba(90, 178, 173, 0.7)" pt="10%">
              <Pdf file={Contrato} />
              <DrawerCloseButton color="red" borderColor="red" pt="15%" />
            </DrawerContent>
          </Drawer>
          <Button
            leftIcon={<FiEye />}
            variant="outline"
            color="#5AB2AE"
            borderColor="#5AB2AE"
            flex={1}
            borderRadius="full"
            _hover={{ bg: 'teal.50' }}
            onClick={() => {
              termosGeraisApp.onOpen();
            }}
          >
            Visualizar Termos
          </Button>
        </HStack>

        <Divider mb={6} />

        <Checkbox
          colorScheme="teal"
          size="lg"
          isChecked={aceito}
          onChange={(e) => setAceito(e.target.checked)}
          mb={6}
          spacing="1rem"
          alignItems="flex-start"
        >
          <Text fontSize="sm" fontWeight="medium" color="gray.700">
            Li e concordo com todos os{' '}
            <Text as="span" color="#5AB2AE" fontWeight="semibold">
              Termos do Contrato de Adesão
            </Text>
          </Text>
        </Checkbox>

        {error && (
          <Text fontSize="sm" color="red.500" mb={4} textAlign="center">
            Ocorreu um erro ao processar sua solicitação. Por favor, tente novamente.
          </Text>
        )}

        <Button
          w="100%"
          bg="#5AB2AE"
          color="white"
          borderRadius="full"
          py={6}
          fontSize="md"
          fontWeight="bold"
          boxShadow="lg"
          _hover={{ bg: '#4AA09C' }}
          isDisabled={!aceito}
          onClick={postAceiteTermo}
          loading={loading}
        >
          Confirmar e Prosseguir
        </Button>
        {!user.id_contrato && dados && (
          <>
            {' '}
            <Button
              mt={4}
              w="100%"
              variant="outline"
              color="gray.600"
              leftIcon={<Icon as={ArrowBackIcon} />}
              borderRadius="full"
              _hover={{ bg: 'gray.50' }}
              onClick={() => {
                if (state.voltar === false) {
                  navigate('/dashboard');
                  return;
                }
                navigate(-1);
              }}
            >
              Voltar
            </Button>
          </>
        )}
      </Box>
    </Flex>
  );
}

export default TermoDeAdesao;
